import React, { useEffect } from 'react';
import cn from 'classnames/bind';

import { FullscreenNotification } from '@/shared/components/FullscreenNotification';

import { useI18n } from '../../hooks/useI18n';

import {
    useInfoBlockFullscreenNotificationReactiveVar,
    infoBlockFullscreenNotificationReactiveVar,
} from './hooks/useInfoBlockFullscreenNotificationReactiveVar';
import styles from './styles.module.css';

const cx = cn.bind(styles);

export const InfoBlockFullscreenNotification = () => {
    const i18n = useI18n();
    const notification = useInfoBlockFullscreenNotificationReactiveVar();
    useEffect(
        () => () => {
            infoBlockFullscreenNotificationReactiveVar.set(undefined);
        },
        []
    );

    if (!notification) {
        return null;
    }

    const { backgroundImage, foregroundImage, primaryButton } = notification;

    const handleClose = () => {
        infoBlockFullscreenNotificationReactiveVar.set(undefined);
    };

    return (
        <FullscreenNotification
            primaryButtonClassName={cx('primaryButton')}
            backgroundImage={backgroundImage}
            foregroundImage={foregroundImage}
            primaryButtonText={primaryButton.text}
            onPrimaryButtonClick={handleClose}
            onCloseButtonClick={handleClose}
            contentLabel={i18n('info_block_notification__content_label')}
            closeButtonText={i18n('info_block_notification__close_button_text')}
        />
    );
};
